import InfiniteScroll from "react-infinite-scroll-component"
import { useCatalogTemplatesQuery } from "./apiQueries"
import { Button, Skeleton, Table } from "antd"
import { CatalogTemplateWithItems } from "../../domain/catalogTemplate"
import Grip from "./Grip"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPlus } from "@fortawesome/pro-solid-svg-icons"

type Props = {
  search: string
  draggable: boolean
  selectedCategories: string[]
  onAddTemplate: (item: CatalogTemplateWithItems) => void
  filterOpen: boolean
  fixedHeight?: string
  docked?: boolean
}

const TemplatesList = ({ search, draggable, selectedCategories, onAddTemplate, filterOpen, fixedHeight, docked }: Props) => {
  const pageSize = 50
  const templatesQuery = useCatalogTemplatesQuery(search, pageSize, selectedCategories)

  const templates = templatesQuery.data?.pages.flatMap(x => x) ?? []
  const hasMore = !templatesQuery.data?.pages.some(x => x.length < pageSize)

  const height = fixedHeight ? fixedHeight : '100vh'
  const yOffset = (filterOpen ? 445 : 270) + (docked && filterOpen ? 100 : 0 )

  return <InfiniteScroll
    height={`calc(${height} - ${yOffset}px)`}
    dataLength={templates.length}
    hasMore={hasMore}
    next={() => templatesQuery.fetchNextPage()}
    loader={<Skeleton active paragraph={{ rows: 1 }} />}
  >
    <Table
      size="small"
      pagination={false}
      dataSource={templates}
      rowKey={x => x.id.toString()}
      showHeader={false}
      columns={[
        {
          render: (_, item) => draggable ? <Grip template={item} /> : <></>
        },
        {
          title: 'Name',
          dataIndex: 'name',
          key: 'name',
          render: (_, item) => <div style={{ cursor: 'pointer' }}>{item.name}</div>
        },
        {
          onCell: () => ({ style: {textAlign: 'right'} }),
          render: (_, item) => {
            return <Button shape="circle" icon={<FontAwesomeIcon icon={faPlus} />} onClick={() => onAddTemplate(item)} />
          }
        }
      ]}
    />
  </InfiniteScroll>
}

export default TemplatesList
